import type { FC } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { illustrationUrl } from '../../StudioBlankSlate';
import BasicBlankSlate from '../../_partials/BasicBlankSlate';

const LITERATURE_IMG_URL = illustrationUrl('studio-literature-empty.png', 2);

const LiteratureBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch(
      pushModal(ModalType.LITERATURE, {
        wrapInModal: false,
        params: {},
      })
    );
  }, [dispatch]);

  return (
    <BasicBlankSlate
      illustrationSrc={LITERATURE_IMG_URL}
      title={t('studio.blankSlate.literature.title')}
      message={t('studio.blankSlate.literature.message')}
      ctaLabel={t('studio.blankSlate.literature.cta')}
      ctaOnClick={onClick}
    />
  );
};
LiteratureBlankSlate.displayName = 'LiteratureBlankSlate';

export default LiteratureBlankSlate;
